export const getAgeCategory = (age) => {
  if (!age) return '';
  const ageNum = parseFloat(age);
  if (ageNum >= 1 && ageNum <= 5) return 'Beginner';
  if (ageNum > 5 && ageNum <= 9) return 'Junior';
  if (ageNum > 9 && ageNum <= 15) return 'Senior';
  return '';
};

export const getEdition = (subscription) => {
  // If edition is explicitly set, use it
  if (subscription.edition) return subscription.edition;

  // Otherwise, calculate from age category (lowercase)
  const ageCategory = getAgeCategory(subscription.childDetails?.age);
  return ageCategory ? ageCategory.toLowerCase() : '';
};

export const getStatusColor = (status) => {
  switch (status) {
    case 'PAID':
    case 'active':
    case 'ACTIVE':
      return 'success';
    case 'FAILED':
    case 'cancelled':
      return 'error';
    case 'INITIATED':
    case 'created':
    case 'authenticated':
      return 'warning';
    case 'halted':
    case 'pending':
      return 'info';
    case 'expired':
    case 'completed':
      return 'secondary';
    default:
      return 'default';
  }
};
